import * as React from "react";

interface Props {
  width?: number;
  height?: number;
}

export const UpdatedOutlined = (props: Props) => (
  <svg
    width={props.width ?? "12"}
    height={props.height ?? "9"}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 7L17 1L15.36 2.64C13.74 1.01 11.49 0 9 0C4.03 0 0 4.03 0 9C0 13.97 4.03 18 9 18C13.97 18 18 13.97 18 9H16C16 12.86 12.86 16 9 16C5.14 16 2 12.86 2 9C2 5.14 5.14 2 9 2C10.93 2 12.68 2.79 13.95 4.05L12 6L18 7Z"
      fill="black"
      fillOpacity="0.6"
    />
    <path
      d="M9 5.95C9.58 5.95 10.05 6.42 10.05 7C10.05 7.58 9.58 8.05 9 8.05C8.42 8.05 7.95 7.58 7.95 7C7.95 6.42 8.42 5.95 9 5.95ZM9 10.45C10.485 10.45 12.05 11.18 12.05 11.5V12.05H5.95V11.5C5.95 11.18 7.515 10.45 9 10.45ZM9 5C7.895 5 7 5.895 7 7C7 8.105 7.895 9 9 9C10.105 9 11 8.105 11 7C11 5.895 10.105 5 9 5ZM9 9.5C7.665 9.5 5 10.17 5 11.5V13H13V11.5C13 10.17 10.335 9.5 9 9.5Z"
      fill="black"
      fillOpacity="0.6"
    />
  </svg>
);
